import { render, staticRenderFns } from "./PropertyRentalsPageTab.vue?vue&type=template&id=599b899f&scoped=true"
import script from "./PropertyRentalsPageTab.vue?vue&type=script&lang=js"
export * from "./PropertyRentalsPageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599b899f",
  null
  
)

export default component.exports